import { COLORS } from "@constants";
import styled from "styled-components";

/**
 * Full-bleed horizontal rule
 *
 * * Ignores the side-padding of every parent container
 * * Won’t break out vertically – you still control the top/bottom margin
 * * Uses the viewport-width trick without introducing a horizontal scrollbar
 */
const FullWidthDivider = styled.hr`
  border: none;
  height: 1px;
  background: ${COLORS.NEUTRAL_200};

  width: 100vw;
  position: relative;
  left: 50%;
  margin-left: -50vw;
  right: 50%;
  margin-right: -50vw;

  margin-top: 2rem;
  margin-bottom: 2rem;

  max-width: calc(100% + (100vw - 100%));
`;

export default FullWidthDivider;
